import { cn } from '../lib/cn.js';

/** Shimmering placeholder — every surface designs its loading state (06). */
export function Skeleton({ className }: { className?: string }) {
  return (
    <div className={cn('bg-raised/70 relative overflow-hidden rounded-md', className)}>
      <div className="animate-shimmer absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/[0.06] to-transparent" />
    </div>
  );
}

export function SkeletonPanel({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <div className={cn('glass space-y-3 p-5', className)}>
      <Skeleton className="h-4 w-1/3" />
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className={cn('h-3', i === lines - 1 ? 'w-2/3' : 'w-full')} />
      ))}
    </div>
  );
}
